export default "__VITE_ASSET__Fmdp$3kM__"